// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._v564ybtr{transition:all .3s}._154iidpf{top:0}\n._1bsb1osq{width:100%}\n._1ltvidpf{left:0}\n._4t3i1osq{height:100%}\n._bfhk326j{background-color:var(--_1ox8nit)}\n._c71l1osq{max-height:100%}\n._kqswstnw{position:absolute}\n._p12f1osq{max-width:100%}", ""]);
// Exports
module.exports = exports;
